module.exports = __webpack_public_path__ + "static/media/sura-plus.7e9657a6.svg";